module.exports = __webpack_public_path__ + "static/RecruitPro_Workflow_hires-0a061319f57ea043f481305142b21a96.jpg";